._buttonDark_1jri3_1 {
  background-color: #aeff84 !important;
  color: #25252a !important; }
  ._buttonDark_1jri3_1:hover {
    opacity: 0.85; }

._buttonSecondaryDark_1jri3_7 {
  background-color: transparent !important;
  color: #fff !important;
  outline-color: #9c9ca2 !important; }
  ._buttonSecondaryDark_1jri3_7:hover {
    outline-color: #aeff84 !important; }

._textButtonDark_1jri3_14 {
  color: #aeff84 !important; }
  ._textButtonDark_1jri3_14:hover {
    opacity: 0.85; }
